import type {Link} from 'src/typings';
import {isPartOfBaseURL} from '../../utils/url-utils';

export function resolveTarget(link: Link): '_self' | '_blank' {
    if (isPartOfBaseURL(link.url)) {
        return '_self';
    }
    return '_blank';
}